export function getWorkflowIconsFromFeatures(features = []) {
  return features.slice().sort((a, b) => {
    var _a$orderIndex, _b$orderIndex;
    return Number((_a$orderIndex = a.orderIndex) !== null && _a$orderIndex !== void 0 ? _a$orderIndex : 0) - Number((_b$orderIndex = b.orderIndex) !== null && _b$orderIndex !== void 0 ? _b$orderIndex : 0);
  }).flatMap(feature => {
    const {
      iconUrl,
      iconActionType,
      actionTypeId,
      name
    } = feature;
    if (iconUrl) {
      var _ref;
      return [{
        actionType: (_ref = actionTypeId !== null && actionTypeId !== void 0 ? actionTypeId : name) !== null && _ref !== void 0 ? _ref : '',
        iconUrl,
        label: name
      }];
    }
    if (iconActionType) {
      return [{
        actionType: iconActionType
      }];
    }
    return [];
  });
}